import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const key = import.meta.env.VITE_MAPS_KEY;

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "15px",
  overflow: "hidden",
};
interface EventMapViewProps {
  latitude: string;
  longitude: string;
}

export const EventMapView = ({
  latitude: latitudeStr,
  longitude: longitudeStr,
}: EventMapViewProps) => {
  const latitude = parseFloat(latitudeStr);
  const longitude = parseFloat(longitudeStr);

  return (
    <LoadScript googleMapsApiKey={key}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={{ lat: latitude, lng: longitude }}
        zoom={14}
        onClick={() => {
          const isMobile = /iPhone|iPad|iPod|Android/i.test(
            navigator.userAgent
          );
          const googleMapsUrl = isMobile
            ? `https://maps.apple.com/?q=${latitude},${longitude}`
            : `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
          window.open(googleMapsUrl, "_blank");
        }}
      >
        <Marker position={{ lat: latitude, lng: longitude }} />
      </GoogleMap>
    </LoadScript>
  );
};
